import { Navigate, useLocation } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { useEffect, useState } from "react";

export default function ProtectedRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  const location = useLocation();

  // Routes where logged-in users should NOT enter
  const restrictedForLoggedIn = ["/login", "/signup"];

  useEffect(() => {
    const checkAuth = async () => {
      const { data } = await supabase.auth.getUser();
      setUser(data?.user || null);
      setLoading(false);
    };
    checkAuth();
  }, []);

  if (loading) return <div className="text-white p-10">Loading...</div>;

  // ⛔ If user is logged in and tries to open /login or /signup
  if (user && restrictedForLoggedIn.includes(location.pathname)) {
    alert("You are already logged in. Logout first to access login/signup.");
    return <Navigate to="/" replace />;
  }

  // 🔐 If no user → send to login page
  if (!user && !restrictedForLoggedIn.includes(location.pathname)) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
